import { useEffect, useState } from "react";

const NAV = [
  { href: "#top", label: "首页" },
  { href: "#archive", label: "名场面图鉴" },
  { href: "#circles", label: "圈子生态" },
  { href: "#rank", label: "本周高能" },
  { href: "#guide", label: "吃瓜指南" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 h-[68px]">
        <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap" aria-label="国产吃瓜 首页">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-film-fill text-xl" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-xl font-bold tracking-tight text-foreground-950">
            国产<span className="text-primary-600">吃瓜</span>
          </span>
        </a>

        <ul className="hidden items-center gap-7 lg:flex">
          {NAV.map((n) => (
            <li key={n.href}>
              <a
                href={n.href}
                className="text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600 whitespace-nowrap"
              >
                {n.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden items-center gap-3 lg:flex">
          <span className="hidden items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-900 whitespace-nowrap">
            <i className="ri-flashlight-fill text-secondary-700" aria-hidden="true"></i>
            持续收录中
          </span>
          <a
            href="#archive"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            去开吃
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="打开菜单"
          aria-expanded={open}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 lg:hidden"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`} aria-hidden="true"></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50/95 px-4 pt-2 pb-4 backdrop-blur lg:hidden">
          <ul className="flex flex-col gap-1">
            {NAV.map((n) => (
              <li key={n.href}>
                <a
                  href={n.href}
                  onClick={() => setOpen(false)}
                  className="flex items-center justify-between rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100"
                >
                  {n.label}
                  <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true"></i>
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}